import React, { Component } from 'react';
import FormViewer from '../FormViewer';
import { checkTranslation } from '../../utils/useful';

class RoomControlComponent extends Component {
    state = {}
    componentDidMount() {
        setTimeout(() => {

            if (this.localVideo) {
                console.log('this.props.localMediaStream.srcObject', this.props.localMediaStream)
                this.localVideo.srcObject = this.props.localMediaStream
                this.localVideo.play()
            }
        }, 30);
    }
    render() {
        return (
            <div className={this.props.padding}>
                {this.props.name &&
                    <p className="font-size-15 px-3 pb-1">{checkTranslation(this.props.name)}</p>
                }
                <div className="flexcb w-100">
                    {this.props.description &&
                        <p className="font-size-14 pld-3">{checkTranslation(this.props.description)}</p>
                    }
                    {this.props.description ?
                        <div style={{ width: '60px' }}>
                            <FormViewer ref={el => this.form = el} headers={this.props.headers} theme={"modern"} inputClass={"modern-input2"} />
                        </div>
                        :
                        <FormViewer ref={el => this.form = el} headers={this.props.headers} theme={"modern"} inputClass={"modern-input5"} />
                    }
                    {this.props.img &&
                        <img src={this.props.img} className="mb-4 mrd-5" />
                    }
                    {this.props.localMediaStream &&
                        // <img src={this.props.img} className="mb-4 mrd-5" />
                        <div className='optionVideo mb-4'>
                            <video id="local-video" className="local-video w-100 h-100" muted playsInline autoPlay={true} ref={vid => this.localVideo = vid}></video>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default RoomControlComponent;